import React, { createContext, useContext, useState } from "react";
import { IntlProvider } from "react-intl";
import { getMessages } from "../i18n";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children, initialLocale }) => {
  const [locale, setLocale] = useState(initialLocale || "en");
  const [messages, setMessages] = useState(getMessages(locale));

  const switchLanguage = (newLocale) => {
    setLocale(newLocale);
    setMessages(getMessages(newLocale));
  };

  return (
    <LanguageContext.Provider value={{ locale, switchLanguage }}>
      <IntlProvider locale={locale} messages={messages} defaultLocale="en">
        {children}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};
